module.exports = __webpack_public_path__ + "c2a3c34c769194e219c37f779b4021fb.svg";